import { render, staticRenderFns } from "./ModalAddContent.vue?vue&type=template&id=63d66103&"
import script from "./ModalAddContent.vue?vue&type=script&lang=js&"
export * from "./ModalAddContent.vue?vue&type=script&lang=js&"
import style0 from "./ModalAddContent.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports